import { InfoPopup } from 'components/popup/InfoPopup';
import { RegisterOptions } from 'react-hook-form';
import styled from 'styled-components';
import { isValidNumber } from 'utils/number';

export const Section = styled.h4`
    margin-top: 0;
    display: flex;
    align-items: center;
`;

export const FeatureIndicatorsSection = () => (
    <Section>
        <span>Feature Indicators</span>
        <InfoPopup title="Feature Indicators">
            Feature indicators will be displayed in the workbench&apos;s trend under the
            analytic&apos;s group. An example of something a feature indicator could track
            is the 1x, 2x, 3x from the spectrum chart.
        </InfoPopup>
    </Section>
);

export const SmartIndicatorsSection = () => (
    <Section>
        <span>Smart Indicators</span>
        <InfoPopup title="Smart Indicators">
            Smart indicators will be displayed in the workbench&apos;s asset card, within
            the MachineIQ tab of the modal. The intent here is to report the probability
            of something happening from a range of 0-1.
        </InfoPopup>
    </Section>
);

export const maxFileSizeBytes = 10 * 1024 * 1024; // 10MB

export const getSourceCodeRules = (isRequired: boolean): RegisterOptions => ({
    validate: (value) => {
        if (!value) {
            return isRequired ? 'Please supply a file' : true;
        }
        if (!value.name.toLowerCase().endsWith('zip')) {
            return 'Must be a zip file';
        }
        if (value.size > maxFileSizeBytes) {
            return 'File can not exceed 10 MB';
        }
        return true;
    },
});

const minTimeIntervalMinutes = 1;
const maxTimeIntervalMinutes = 120;

export const timeIntervalRules: RegisterOptions = {
    validate: (value: string) => {
        if (!value) {
            return `Please enter a time interval.`;
        }

        if (!isValidNumber(value)) {
            return `Time interval must be a number.`;
        }

        const parsedValue = Number(value);

        if (!Number.isInteger(parsedValue)) {
            return `Time interval must be a whole number.`;
        }

        if (parsedValue > maxTimeIntervalMinutes) {
            return `$Time Interval cannot be greater than ${maxTimeIntervalMinutes} minutes.`;
        }

        if (parsedValue < minTimeIntervalMinutes) {
            return `Time Interval must be at least ${minTimeIntervalMinutes} minute.`;
        }

        return true;
    },
};
